export default "__VITE_ASSET__Blnfz2Gk__"